

// 1: 未登陆 2 登陆 3 空闲 4 忙碌 6 响铃 8 拨号 10 通话中 13 没有网络(SDK的) 14下线 15状态正在切换
export enum EnumCallSystemStatus {
    notLogin = 1,
    login = 2,
    free = 3,
    busy = 4,
    hangUp = 6,
    calling = 8,
    saying = 10,
    notNet = 13,
    notOnline = 14,
    switching = 15
}

export enum EnumCallProvide {
    aliyun = 'aliyun',
    fbocc = 'fbocc ',
    tengxun = 'tengxun'
}

export enum EnumCallCenterType {
     OB = 1,
    ALI = 2,
    TIAN_RUN = 3,
    QI_DIAN = 4,
    SEVEN_MOOR = 5,
    FBOCC = 6,
    WORK_PHONE = 7,
    ENTERPRISE_WECHAT = 8,
    ALI_2 = 9,
}

export enum EnumCallingStatus{
    onLine = '1',
    notOnline = '0'
}

export enum EnumPlatform{
    fbocc = 'fbocc',
    aliyun = 'aliyun',
    tengxun = 'tengxun',
    aliyunPlus = 'aliyunPlus',
    tianrun = 'tianrun'
}

// 1001 标准话务 请求话务配置接口报错  1002 标准话务 不存在对应座席的话务配置
export enum EnumCallInitStatus{
    registeErr = '0000',
    callConfigErr = '1001',
    callConfigEmpty = '1002',
    connectFail = '4004', //异常下线的问题
}

export enum EnumPlatformStatus{
    web = '1',
    client = '0'
}